var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMessages = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.518 42H56.5714C34.2428 42 16 59.7521 16 81.8235V220C16 221.589 16.9403 223.027 18.3957 223.664C19.851 224.301 21.5456 224.017 22.713 222.939L67.6439 181.467H175.52C197.404 181.467 216 166.997 216 144.515V81.8235C216 81.2311 215.987 80.6418 215.961 80.0559C213.694 83.0635 211.012 85.7408 208 88.0029V144.515C208 161.602 194.031 173.467 175.52 173.467H66.08C65.0745 173.467 64.1058 173.845 63.367 174.527L24 210.864V81.8235C24 64.3254 38.5044 50 56.5714 50H144.447C144.864 47.2301 145.564 44.5533 146.518 42Z",
    fill: "#2D2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184 88C201.673 88 216 73.6731 216 56C216 38.3269 201.673 24 184 24C166.327 24 152 38.3269 152 56C152 73.6731 166.327 88 184 88ZM184 96C206.091 96 224 78.0914 224 56C224 33.9086 206.091 16 184 16C161.909 16 144 33.9086 144 56C144 78.0914 161.909 96 184 96Z",
    fill: "#2D2D2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96 112C96 116.418 92.4183 120 88 120C83.5817 120 80 116.418 80 112C80 107.582 83.5817 104 88 104C92.4183 104 96 107.582 96 112Z",
    fill: "#2D2D2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128 112C128 116.418 124.418 120 120 120C115.582 120 112 116.418 112 112C112 107.582 115.582 104 120 104C124.418 104 128 107.582 128 112Z",
    fill: "#2D2D2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160 112C160 116.418 156.418 120 152 120C147.582 120 144 116.418 144 112C144 107.582 147.582 104 152 104C156.418 104 160 107.582 160 112Z",
    fill: "#2D2D2D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M204 56C204 67.0457 195.046 76 184 76C172.954 76 164 67.0457 164 56C164 44.9543 172.954 36 184 36C195.046 36 204 44.9543 204 56Z",
    fill: "#2D2D2D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMessages);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/messages.e22ae8276ac5a0d5571ba210c738a9fe.svg";